import { MessageSquare, Clock, Calendar } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useSessions } from '@/hooks/useApi';

export function SessionStats() {
  const { data: sessions } = useSessions();

  if (!sessions || sessions.length === 0) {
    return null;
  }

  const totalSessions = sessions.length;

  // Find most recent session
  const mostRecentSession = sessions.reduce((latest, session) => {
    const latestTime = latest.lastUpdateTime || '';
    const sessionTime = session.lastUpdateTime || '';
    return sessionTime > latestTime ? session : latest;
  });

  // Calculate sessions created in last 7 days
  // Since we don't have separate creation time, use lastUpdateTime as approximation
  const weekAgo = new Date();
  weekAgo.setDate(weekAgo.getDate() - 7);
  const weekAgoISOString = weekAgo.toISOString();
  const recentSessions = sessions.filter(session =>
    session.lastUpdateTime && session.lastUpdateTime > weekAgoISOString
  ).length;

  const stats = [
    {
      label: 'Total Sessions',
      value: totalSessions,
      icon: MessageSquare,
      color: 'text-blue-600',
    },
    {
      label: 'This Week',
      value: recentSessions,
      icon: Calendar,
      color: 'text-orange-600',
    },
  ];

  return (
    <div className="p-2 space-y-2">
      <div className="grid grid-cols-2 gap-2">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.label} className="border-0 bg-muted/30">
              <CardContent className="p-2">
                <div className="flex items-center gap-2">
                  <Icon className={`h-3 w-3 ${stat.color}`} />
                  <div className="min-w-0 flex-1">
                    <p className="text-xs font-medium">{stat.value}</p>
                    <p className="text-xs text-muted-foreground truncate">
                      {stat.label}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Last activity */}
      <Card className="border-0 bg-muted/30">
        <CardContent className="p-2">
          <div className="flex items-center gap-2">
            <Clock className="h-3 w-3 text-muted-foreground" />
            <div className="min-w-0 flex-1">
              <p className="text-xs font-medium">Last Activity</p>
              <p className="text-xs text-muted-foreground truncate">
                {mostRecentSession.lastUpdateTime ? new Date(mostRecentSession.lastUpdateTime).toLocaleString() : 'No activity'}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}